// src/pages/B2B/event-reports/components/ReportTypeSelect.tsx
import React from 'react';

interface Props {
  value: 'report_for_businesses';
  onChange: (v: 'report_for_businesses') => void;
}

export function ReportTypeSelect({ value, onChange }: Props): React.ReactElement {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as 'report_for_businesses')}
      className="px-3 py-2 text-sm bg-gray-900 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:border-violet-500"
    >
      <option value="report_for_businesses">Report for Businesses</option>
    </select>
  );
}
